/*=========================================================================================
File Name: main.js
Description: main vue(js) file
----------------------------------------------------------------------------------------
Item Name: Vuesax Admin - VueJS Dashboard Admin Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import lodash from 'lodash'
import './tirocini'
// import './reports' search this file for './reports'
import './aziende'
import './rimborsi'
import './tariffe'
import './http'
import App from './App.vue'
import VueI18n from 'vue-i18n'

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

import Datepicker from '@sum.cumo/vue-datepicker';
import * as dplangs from 'vuejs-datepicker/src/locale';
Vue.prototype.$date_lang = dplangs.it
Vue.component('v-date', Datepicker)
import Tooltip from 'tooltip-js'
Vue.component(Tooltip)
// import Popper from 'popper.js'
// Vue.component(Popper)
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)
// const { JSDOM } = require("jsdom")
// const { window } = new JSDOM( "" )
// const $ = require( "jquery" )( window )

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// ACL
import acl from './acl/acl'

// Vuesax Admin Filters
import './filters/filters'

// Vue-Cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Leads
import vueKanban from 'vue-kanban'
Vue.use(vueKanban)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// VueTour => https://github.com/pulsardev/vue-tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import vueSignature from "vue-signature"
Vue.use(vueSignature)

import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import VueCurrencyInput from 'vue-currency-input'
const vueCurrOpt = {
  /* see config reference */
  globalOptions: {  currency: 'EUR',
                    locale: 'it-IT',
                    precision: 2,
                    'distraction-free': true,
                    'allow-negative': true }
}
Vue.use(VueCurrencyInput, vueCurrOpt)

// // Vue Simple Calendar
// import { VueSimpleCalendar } from 'vue-simple-calendar'
// Vue.use(VueSimpleCalendar)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
    // The relative path of the components folder
    './components/global',
    // Whether or not to look in subfolders
    true,
    // The regular expression used to match base component filenames
    /[A-Za-z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)

    // Get PascalCase name of component
    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
            .split('/')
            .pop()
            .replace(/\.\w+$/, '')
        )
    )


    // Register component globally
    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
    )
})

// Feather font icon
require('./assets/css/iconfont.css')

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: process.env.VUE_APP_MAPS_KEY,
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})



Vue.prototype._ = window._ = lodash
Vue.use(VueI18n)
let i18n = new VueI18n({
  locale: 'it',
  messages: {
      it: {
          message: {},
      }
  }
})
let $utc = Vue.prototype.$utc = str => {
    if (!str || typeof str != 'string') return new Date()
    let pieces = str.match(/\d+/g)
    // console.log(str, pieces)
    // console.log(pieces)
    return new Date(Date.UTC(Number(pieces[0]), Number(pieces[1])-1, Number(pieces[2]),
    Number(pieces[3] || 0), Number(pieces[4] || 0), Number(pieces[5] || 0)))
}
Vue.prototype.$elapsedTime = (startTime) => {
    let x = $utc(startTime);
    let now = new Date();
    var timeDiff = now - x;
    timeDiff /= 1000;
    console.log(timeDiff)

    var seconds = Math.round(timeDiff);
    timeDiff = Math.floor(timeDiff / 60);

    var minutes = Math.round(timeDiff % 60);
    timeDiff = Math.floor(timeDiff / 60);

    var hours = Math.round(timeDiff % 24);
    timeDiff = Math.floor(timeDiff / 24);

    var days = Math.round(timeDiff % 365);
    timeDiff = Math.floor(timeDiff / 365);

    var years = timeDiff;

    if (years > 0) {
        return years + (years > 1 ? ' Anni ' : ' Anno ') + 'fa';
    } else if (days > 0) {
        return days + (days > 1 ? ' Giorni ' : ' Giorno ') + 'fa';
    } else if (hours > 0) {
        return hours + (hours > 1 ? ' Ore ' : ' Ora ') + 'fa';
    } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' Min ' : ' Min ') + 'fa';
    } else if (seconds > 0) {
        return (seconds > 1 ? `${seconds} secondi fa` : 'ora');
    }

    return 'Ora'
}
Vue.config.productionTip = false


/*GLOBAL REPORTS*/
Vue.prototype.$sidebar = {
    stato: false,
    cerca: false,
    cercaAziende: false,
    trovatoAziende: false
  }
/*GLOBAL REPORTS SIDEBAR*/
import {sidebarReportsData, sidebarReportsValue} from './reports'
Vue.prototype.$sidebarReportsData = sidebarReportsData.data
Vue.prototype.$sidebarReportsValue = sidebarReportsValue
Vue.prototype.$sidebarReportsValue.listaAziende = []

new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')
